import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'

import SOUNDS from 'sounds'

export const RESERVE_PRODUCE_SUBMIT_REQUEST = 'reserve_produce/SUBMIT_REQUEST'
export const RESERVE_PRODUCE_SUBMIT_SUCCESS = 'reserve_produce/SUBMIT_SUCCESS'
export const RESERVE_PRODUCE_SUBMIT_ERROR = 'reserve_produce/SUBMIT_ERROR'
export const RESERVE_PRODUCE_CHANGE_SELECTED_COUNT = 'reserve_produce/CHANGE_SELECTED_COUNT'

export function reserveProduceRequest() {
    return {
        type: RESERVE_PRODUCE_SUBMIT_REQUEST,
        payload: {},
    }
}

export function reserveProduceSuccess(buildingId, data) {
    const industrialResourceBalance = data.industrial_resource_balance
    const producedReserves = data.reserves
    return {
        type: RESERVE_PRODUCE_SUBMIT_SUCCESS,
        payload: { buildingId, industrialResourceBalance, producedReserves },
        meta: {
            webToClient: {
                handler: 'playSound',
                params: { soundId: SOUNDS.RESERVE_PRODUCE_START },
            },
        },
    }
}

export function reserveProduceError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: RESERVE_PRODUCE_SUBMIT_ERROR,
        payload: errorData,
    }
}

export function changeSelectedCount(selectedCount, playSound = true) {
    const action = {
        type: RESERVE_PRODUCE_CHANGE_SELECTED_COUNT,
        payload: { selectedCount },
    }

    if (playSound) {
        action.meta = {
            webToClient: {
                handler: 'playSound',
                params: { soundId: SOUNDS.SELECT_CLICK },
            },
        }
    }
    return action
}

export default function submitReserveProduce(buildingId, count, level) {
    return async (dispatch, getState) => {
        const state = getState()
        if (state.reserveProduce.submitting) {
            return
        }
        dispatch(reserveProduceRequest(buildingId))
        const url = `/game_api/buildings/${buildingId}/reserves`
        const method = 'POST'
        const data = { count, level }
        httpRequest(url, method, data)
            .then(
                resp => dispatch(reserveProduceSuccess(buildingId, resp)),
                errorData => dispatch(reserveProduceError(errorData)),
            )
    }
}



// WEBPACK FOOTER //
// ./state/actions/reserve_produce.js